import {UI} from "../../../../stem-core/src/ui/UIBase.js";
import {BasePanelPage} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {Flow} from "../../flows/Flow.js";
import {BlinkButton} from "../../../../core/ui/Button.jsx";


export class ProductPanel extends UI.Element {
    render() {
        const {product} = this.options;

        return [
            <h1>{product.name}</h1>,

            <MessageElement message={product.description} />,

            <div>Price: {product.getAmount()}</div>,

            product.requiresAddress && <div>Address Required</div>,

            <BlinkButton
                label={Messages.shopBuyNow}
                onClick={() => Flow.productList.selectValue(product)}
            />,
            <hr/>
        ]
    }
}

export class ShopPanel extends BasePanelPage {
    render() {
        const products = iFrameState.getProducts();
        return products.length === 0 ? ["No products available"] : products.map(product => <ProductPanel product={product} />);
    }
}
